import { toast as originalToast } from 'react-toastify';

// Custom toast wrapper that adds data-testid attributes
const createToastWithTestId = (type) => (message, options = {}) => {
  // Create a custom component that includes data-testid
  const ToastComponent = ({ closeToast }) => (
    <div data-testid={`${type}-toast`} className={`toast-content toast-${type}-content`}>
      {message}
    </div>
  );

  const toastOptions = {
    ...options,
    className: (context) => `Toastify__toast Toastify__toast--${type} toast-${type}`,
    bodyClassName: () => `Toastify__toast-body toast-${type}-body`,
    progressClassName: () => `Toastify__progress-bar toast-${type}-progress`,
  };

  return originalToast(ToastComponent, toastOptions);
};

export const toast = {
  success: createToastWithTestId('success'),
  error: createToastWithTestId('error'),
  warn: createToastWithTestId('warn'),
  warning: createToastWithTestId('warn'), // alias for warn
  info: createToastWithTestId('info'),
  // Keep original methods for any edge cases
  ...originalToast
};

export default toast;
